// Shared bits for the Transfers and Lends screens (warehouse Phase 3).

export const roundQty = (value) => Math.round((Number(value) || 0) * 1000) / 1000;

export const errorMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback;

/** Today as YYYY-MM-DD in the browser's time zone (the minimum lend due date). */
export const todayISO = () => new Date().toLocaleDateString('en-CA');

/** "12 Oct 2026" for a date-only value or a timestamp. */
export const formatDate = (value) => {
  if (!value) return '—';
  const text = String(value);
  const date = /^\d{4}-\d{2}-\d{2}$/.test(text) ? new Date(`${text}T00:00:00`) : new Date(text);
  if (Number.isNaN(date.getTime())) return text;
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString('en-IN') : '—');

/** Status of a transfer or lend: label and StatusPill tone. */
export const TRANSFER_STATUS = {
  completed: { label: 'Completed', tone: 'success' },
  open: { label: 'Open', tone: 'warning' },
  returned: { label: 'Returned', tone: 'neutral' },
  converted: { label: 'Converted to transfer', tone: 'info' }
};

export const transferStatus = (status) =>
  TRANSFER_STATUS[status] || { label: status || '—', tone: 'neutral' };

export const transferTypeLabel = (type) => (type === 'lend' ? 'Lend' : 'Transfer');
